// extracted by mini-css-extract-plugin
export default {"wrapper":"_R-z","availablePromoMessagesLabel":"aS-z","promoMessageList":"bS-z","promoMessage":"cS-z","appliedPromoMessage":"dS-z","promoMessageAmount":"eS-z"};